const carousels = async function () {
    const brandsCarousel = [...document.querySelectorAll(".brands-carousel")];
    const topContentAndCarousel = [...document.querySelectorAll(".top-content-and-carousel")];
    const cardsCarousel = [...document.querySelectorAll(".cards-carousel")];

    const cacheAnimation = {};
    
    async function loadAnimation(url) {
        if (cacheAnimation[url]) return cacheAnimation[url];
        const response = await fetch(url);
        const json = await response.json();
        cacheAnimation[url] = json;
        return json;
    }

    if (brandsCarousel || topContentAndCarousel || cardsCarousel) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (brandsCarousel) {
            brandsCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    lazy: true,
                    loop: true,
                    slidesPerView: 2,
                    spaceBetween: 115,
                    simulateTouch: false,
                    allowTouchMove: false,
                    freeMode: true,
                    speed: 5000,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 5,
                        }
                    }
                })
            })
        }

        if (topContentAndCarousel) {
            await import("@lottiefiles/lottie-player");
            
            topContentAndCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    speed: 850,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        prevEl: section.querySelector(".swiper-button-prev"),
                        nextEl: section.querySelector(".swiper-button-next"),
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    on: {
                        async slideChange() {
                            const lottie = this.slides[this.activeIndex].querySelector("lottie-player");
                            const animation = await loadAnimation(lottie.dataset.src);
                            lottie.load(animation);
                            lottie.play();
                        }
                    }
                });
            });
        }
        if (cardsCarousel) {
            cardsCarousel.forEach(section => {
                const slidesPerViewDefault = section.classList.contains("square-slides") ? 1.5 : 1.1;

                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: section.querySelectorAll(".swiper-slide").length > 1,
                    slidesPerView: slidesPerViewDefault,
                    spaceBetween: 20,
                    navigation: {
                        prevEl: section.querySelector(".swiper-button-prev"),
                        nextEl: section.querySelector(".swiper-button-next"),
                    },
                    speed: 3000,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                    },
                    lazy: true,
                    breakpoints: {
                        640: {
                            slidesPerView: 1.5,
                        },
                        768: {
                            slidesPerView: 2.1,
                        },
                        1024: {
                            slidesPerView: 2.5,
                        }
                    }
                
                });
            });
        }
    }
}

export const init = carousels;